// Estilos do seletor de host/interface vinculados e do status do host no painel de inspeção do nó
const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  optionLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.palette.text.primary,
  },
  // Mesmo tratamento do Autocomplete de host (Nome), ao lado
  listbox: {
    maxHeight: "min(320px, calc(100vh - 200px))",
    overflowY: "auto",
  },
  optionCheckbox: {
    mr: 1,
    p: 0,
  },
  // Resumo "N selecionada(s)" que substitui os chips individuais no campo de interfaces
  selectedSummary: {
    color: theme.palette.text.secondary,
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.75,
  },
  statusLabel: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
});

export default styles;
